// extracted by mini-css-extract-plugin
export default {"infoTable":"hcx-card-summary-info_infoTable__Bj8QF","highlightsTitle":"hcx-card-summary-info_highlightsTitle__dAjwG","pointer":"hcx-card-summary-info_pointer__uKPAA"};